import { render, staticRenderFns } from "./CardWidget.vue?vue&type=template&id=31b1ce41"
import script from "./CardWidget.vue?vue&type=script&lang=js"
export * from "./CardWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports